<template>
    <BreadCrumb PageTitle="Historique de lecture" />
    <HistoriqueLecture />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import HistoriqueLecture from "../../components/Historique/HistoriqueLecture.vue";

  export default defineComponent({
    name: "HistoriqueLecturePage",
    components: {
      BreadCrumb,
      HistoriqueLecture,
    },
  });
  </script>